<template>
    <div class="right-content-container">
        <!--显示我们的内容-->
        <div class="content-title-box">
            <span class="back-btn el-icon-back" @click="$router.back()">返回</span>
            <span v-text="$route.name"></span>
        </div>
        <div class="content-container-box">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
    export default {}
</script>
<style>
    .content-title-box .back-btn:hover {
        opacity: .5;
    }

    .content-title-box .back-btn {
        margin-right: 20px;
        color: #9d9d9d;
        cursor: pointer;
    }

    .right-content-container {
        min-width: 1140px;
        padding: 20px;
    }

    .content-container-box {

    }

    .content-title-box {
        margin-bottom: 20px;
        font-size: 20px;
        line-height: 30px;
    }
</style>
